/* Copyright (C) 2011-2018 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */
// 1. React and fabric. 
// 2. Store and Types. 
// 3. Scripts. 
import { sPLATFORM_LAYOUT, bDESKTOP_LAYOUT } from '../scripts/SplendidInitUI';
import { EndsWith } from '../scripts/utility';

export default class SplendidDynamic
{
	// 06/18/2015 Paul.  Add support for Seven theme. 
	static StackedLayout(sTheme: string, sViewName?: string): boolean
	{
		if (sViewName === undefined || sViewName == null)
			sViewName = '';
		// 04/02/2022 Paul.  Pacific uses stacked action menus. 
		return (sTheme === 'Seven' || sTheme === 'Pacific') && !EndsWith(sViewName, '.Preview');
	}

	// 04/08/2017 Paul.  Use Bootstrap for responsive design.
	static BootstrapLayout(): boolean
	{
		// 06/24/2017 Paul.  We need a way to turn off bootstrap for BPMN, ReportDesigner and ChatDashboard. 
		return !bDESKTOP_LAYOUT && sPLATFORM_LAYOUT != '.OfficeAddin';
	}
}

